import { render } from "./Channels.vue?vue&type=template&id=1b4c527b&scoped=true"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"

import "./Channels.vue?vue&type=style&index=0&id=1b4c527b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4c527b"]])

export default __exports__